import { LegendOrdinal } from '@visx/legend'
import { scaleOrdinal } from '@visx/scale'
import React from 'react'
import getPercentLegend from '../helpers/getPercentLegend'
import getReadableLabel from '../helpers/getReadableLabel'

export default function ChartLegend( { perType } ) {
  const threshold = scaleOrdinal( {
    domain : Object.keys( perType ?? {} ),
    range : [ '#FA5E7B', '#63C6C9' ],
  } )

  return (
    <LegendOrdinal
      shape="square"
      scale={threshold}
      direction="column"
      itemMargin="8px 0px 8px 8px"
      labelFormat={label => `${getReadableLabel( label )} ${getPercentLegend(
        perType,
        perType[label],
      )}%`}
      labelAlign="left"
      style={{
        display : 'flex',
        justifyContent : 'center',
        whiteSpace : 'nowrap',
        backgroundColor : 'transparent'
      }}/>
  )
}
